module.exports = __webpack_public_path__ + "img/card_lima_background.6162f312.png";